<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase>
    <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.07972 5.53344C7.26221 3.79347 8.62332 2.33344 10.5 2.33344C12.3767 2.33344 13.7378 3.79347 13.9203 5.53344H17V15.7334C17 17.1694 15.8873 18.3334 14.5147 18.3334H6.48529C5.1127 18.3334 4 17.1694 4 15.7334V5.53344H7.07972ZM8.23673 5.53344H12.7633C12.5902 4.42236 11.7042 3.53344 10.5 3.53344C9.29581 3.53344 8.40981 4.42236 8.23673 5.53344ZM7.05882 6.73344H5.14706V15.7334C5.14706 16.5066 5.74621 17.1334 6.48529 17.1334H14.5147C15.2538 17.1334 15.8529 16.5066 15.8529 15.7334V6.73344H13.9412V8.73344H12.7941V6.73344H8.20588V8.73344H7.05882V6.73344Z"
        fill="currentColor"
      />
    </svg>
  </IconBase>
</template>
